<!-- Department header -->
<app-dept-header></app-dept-header>
<!-- Department header -->

<!-- Page Content -->
<div id="page-content">
  <div class="container">
    <div class="row">
      <!--MAIN Content-->
      <div class="col-md-12">
        <div id="page-main">
          <section class="blog-listing" id="blog-listing">
            <header><h1>Programmes</h1></header>
            <div class="row">

              <div class="col-md-4 col-sm-4" *ngFor="let degree of degreeData">
                <article class="blog-listing-post">
                  <figure class="blog-thumbnail">
                    <figure class="blog-meta"><span class="fa fa-file-text-o"></span>{{degree.duration}} - {{degree.deg_type.deg_type}}</figure>
                    <div class="image-wrapper"><a routerLink="/degreedet/{{degree.id}}"><img src="{{degree.image}}"></a></div>
                  </figure>
                  <aside>
                    <header>
                      <a routerLink="/degreedet/{{degree.id}}"><h3>{{degree.degree_name}}</h3></a>
                    </header>
<!--                    <div class="description" *ngIf="degree.description !== null">-->
<!--                      <p>-->
<!--                        {{degree.description}}-->
<!--                      </p>-->
<!--                    </div>-->
<!--                    <a href="#" class="read-more stick-to-bottom">Read More</a>-->
                  </aside>
                </article><!-- /article -->
              </div><!-- /.col-md-6 -->

            </div><!-- /.row -->

          </section><!-- /.blog-listing -->
        </div><!-- /#page-main -->
      </div><!-- /.col-md-8 -->

    </div><!-- /.row -->
  </div><!-- /.container -->
</div>
<!-- end Page Content -->
